module.exports = __webpack_public_path__ + "static/media/bg-product.9584f71d.mp4";